import {Repository} from '@/repositories/Base/Repository'

class MaterialRepository extends Repository {
    endpoint = 'mapping/specimens/table'
    endpointCopy = 'mapping/specimens/copy'
    postCopy(params) {
        return this.$axios.post(`${this.endpointCopy}`, params)
    }
}

export default new MaterialRepository()
